import { useState, useEffect } from 'react';
import { fetchExploreFeed, fetchProfileBlocks } from '@ego/api';
import { relativeTime } from '@ego/domain';
import { getImageUrl } from '@ego/api';
import useAuth from './useAuth';

export default function useAllBlocks(handle) {
  const { session } = useAuth();
  const [blocks, setBlocks] = useState([]);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    let cancelled = false;
    setLoading(true);
    const loader = handle
      ? fetchProfileBlocks(handle, session?.access_token).then(({ blocks: items }) => ({
          items: items.map(item => ({
            ...item,
            channel: item.channel,
            profile: { handle: item.profile.handle },
            imagePath: item.imagePath,
          })),
        }))
      : fetchExploreFeed(undefined, 100);

    loader
      .then(({ items }) => {
        if (cancelled) return;
        setBlocks(items.map(item => ({
          id: item.id,
          type: item.type,
          title: item.title,
          content: item.content,
          imageUrl: getImageUrl(item.imagePath),
          sourceUrl: item.sourceUrl,
          sourceAuthor: item.sourceAuthor,
          channelTitle: item.channel?.title || '',
          channelSlug: item.channel?.slug || '',
          channelHandle: item.profile?.handle || '',
          channelModified: relativeTime(item.channel?.updatedAt || item.updatedAt),
          updated: relativeTime(item.updatedAt),
        })));
      })
      .catch(() => { if (!cancelled) setBlocks([]); })
      .finally(() => { if (!cancelled) setLoading(false); });

    return () => { cancelled = true; };
  }, [handle, session?.access_token]);

  return { blocks, loading };
}
